// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Spinner {\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    z-index: 99999;\r\n}\r\n\r\n.ms-Spinner-circle {\r\n    width: 25px;\r\n    height: 25px;\r\n}\r\n\r\n.ms-Spinner-label {\r\n    font-size: 18px;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
